import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageFavorites from '@/pages/account/favorites'

export const Route = createFileRoute('/app/account/favorites')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageFavorites />
}
